import { connect } from 'react-redux'
import { toggleIndustry } from './actions'
import Popup from '../components/popup/index';

const mapStateToPropsRes = (state) => {

  return {
    data: state.popup.activePopupData,
    elementID: 'popup',
    title: state.popup.title,
  //  position: state.industries.activePopupPosition,
  //  positioning: state.industries.activePopupPosPositioning,
  }
}

const IndustriesContainer = connect(
  mapStateToPropsRes
)(Popup);

export default IndustriesContainer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/popup/container.js